@if (landingPage$(); as page) {
  <article class="landing-page">
    @switch (page.header.type) {
      @case ('header-gallery') {
        <app-header-gallery [header]="page.header"></app-header-gallery>
      }
      @case ('header-card-grid') {
        <app-header-card-grid [header]="page.header" [cookiePreferences]="cookiePreferences$() || undefined"></app-header-card-grid>
      }
      @case ('header-standard') {
        <app-header-standard [header]="page.header"></app-header-standard>
      }
      @case ('header-card-slider') {
        <app-header-card-slider [header]="page.header" [cookiePreferences]="cookiePreferences$() || undefined"></app-header-card-slider>
      }
      @case ('header-library') {
        <app-header-library [header]="page.header" [cookiePreferences]="cookiePreferences$() || undefined">
          <app-library-search-field></app-library-search-field>
        </app-header-library>
      }
      @default {
        <app-header-content-page [header]="page.header"></app-header-content-page>
        <!--<app-header [title]="page.title"></app-header>-->
      }
      <!-- ect -->
    }

    @if (page.contentBlocks.length) {
      <main>
        <app-content-block-container
          [blocks]="page.contentBlocks"
          [header]="page.header"
          [showAnchors]="showAnchors()"
        ></app-content-block-container>
      </main>
    }
  </article>
}
